<template lang="html">
  <div>
    <div class="nav">
      <a-carousel autoplay>
        <img src="../assets/banner-1.jpg" alt="" style="height:500px;" />
        <img src="../assets/banner-3.jpg" alt="" style="height:500px;" />
        <img src="../assets/banner-2.jpeg" alt="" style="height:500px;" />
      </a-carousel>
    </div>
    <div class="drugList" v-show="isShow0">
      <div class="goods" v-for="item in goodsList0" :key="item.id">
        <img alt="" :src="item.goodsPic" />
        <div class="goodsTitle">{{ item.goodsName }}</div>
        <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
      </div>
    </div>
    <div class="drugList" v-show="isShow1" style="height:900px;">
      <div class="goods" v-for="item in goodsList1" :key="item.id">
        <img alt="" :src="item.goodsPic" />
        <div class="goodsTitle">{{ item.goodsName }}</div>
        <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
      </div>
    </div>
    <div class="drugList" v-show="isShow2" style="height:900px;">
      <div class="goods" v-for="item in goodsList2" :key="item.id">
        <img alt="" :src="item.goodsPic" />
        <div class="goodsTitle">{{ item.goodsName }}</div>
        <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
      </div>
    </div>
    <div class="drugList" v-show="isShow3" style="height:900px;">
      <div class="goods" v-for="item in goodsList3" :key="item.id">
        <img alt="" :src="item.goodsPic" />
        <div class="goodsTitle">{{ item.goodsName }}</div>
        <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
      </div>
    </div>
    <div class="drugList" v-show="isShow4" style="height:900px;">
      <div class="goods" v-for="item in goodsList4" :key="item.id">
        <img alt="" :src="item.goodsPic" />
        <div class="goodsTitle">{{ item.goodsName }}</div>
        <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
      </div>
    </div>
    <div class="drugList" v-show="isShow5" style="height:1800px;">
      <div class="goods" v-for="item in goodsList5" :key="item.id">
        <img alt="" :src="item.goodsPic" />
        <div class="goodsTitle">{{ item.goodsName }}</div>
        <div class="isShow" @click="handleDrugDetails(item.id)">查看详情</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "informationService",
  components: {
  },
  data() {
    return {
      isShow0: false,
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      menuTitle: "全部分类",
      goodsList0: [
        {
          id: 1,
          goodsPic: require("../assets/drug-1.jpg"),
          goodsName: "感冒灵颗粒",
        },
        {
          id: 2,
          goodsPic: require("../assets/drug-2.png"),
          goodsName: "板蓝根颗粒",
        },
        {
          id: 3,
          goodsPic: require("../assets/drug-3.png"),
          goodsName: "复方青橄榄利咽含片",
        },
        {
          id: 4,
          goodsPic: require("../assets/drug-4.png"),
          goodsName: "感冒清热颗粒",
        },
        {
          id: 5,
          goodsPic: require("../assets/drug-5.png"),
          goodsName: "夏桑菊颗粒",
        },
        {
          id: 6,
          goodsPic: require("../assets/drug-6.png"),
          goodsName: "健胃消食片",
        },
        {
          id: 7,
          goodsPic: require("../assets/drug-7.png"),
          goodsName: "肠炎宁片",
        },
        {
          id: 8,
          goodsPic: require("../assets/drug-8.png"),
          goodsName: "奥美拉唑肠溶胶囊",
        },
        {
          id: 9,
          goodsPic: require("../assets/drug-9.png"),
          goodsName: "养胃舒胶囊",
        },
        {
          id: 10,
          goodsPic: require("../assets/drug-10.png"),
          goodsName: "铝碳酸镁片",
        },
        {
          id: 11,
          goodsPic: require("../assets/drug-11.png"),
          goodsName: "维生素AD滴剂",
        },
        {
          id: 12,
          goodsPic: require("../assets/drug-12.png"),
          goodsName: "丁桂儿脐贴",
        },
        {
          id: 13,
          goodsPic: require("../assets/drug-13.png"),
          goodsName: "葡萄糖酸锌口服溶液",
        },
        {
          id: 14,
          goodsPic: require("../assets/drug-14.png"),
          goodsName: "三公仔",
        },
        {
          id: 15,
          goodsPic: require("../assets/drug-15.png"),
          goodsName: "布洛芬混悬液",
        },
        {
          id: 16,
          goodsPic: require("../assets/drug-16.png"),
          goodsName: "洁尔阴洗液",
        },
        {
          id: 17,
          goodsPic: require("../assets/drug-17.png"),
          goodsName: "硝呋太尔制霉素阴道软胶囊",
        },
        {
          id: 18,
          goodsPic: require("../assets/drug-18.png"),
          goodsName: "乌鸡白凤丸(水蜜丸)",
        },
        {
          id: 19,
          goodsPic: require("../assets/drug-19.png"),
          goodsName: "妇科千金片",
        },
        {
          id: 20,
          goodsPic: require("../assets/drug-20.png"),
          goodsName: "妇炎康片",
        },
        {
          id: 21,
          goodsPic: require("../assets/drug-21.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 22,
          goodsPic: require("../assets/drug55.png"),
          goodsName: "欧姆龙电子血糖仪",
        },
        {
          id: 23,
          goodsPic: require("../assets/drug-23.png"),
          goodsName: "鱼跃电子血氧仪",
        },
        {
          id: 24,
          goodsPic: require("../assets/drug-24.png"),
          goodsName: "儿童电子温度计",
        },
        {
          id: 25,
          goodsPic: require("../assets/drug-25.png"),
          goodsName: "胎心检测仪",
        },
        {
          id: 26,
          goodsPic: require("../assets/drug-26.png"),
          goodsName: "腰椎固定带",
        },
        {
          id: 27,
          goodsPic: require("../assets/drug-27.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 28,
          goodsPic: require("../assets/drug-28.png"),
          goodsName: "欧姆龙压缩式雾化器",
        },
        {
          id: 29,
          goodsPic: require("../assets/drug-29.png"),
          goodsName: "负压拔罐器",
        },
        {
          id: 30,
          goodsPic: require("../assets/drug-30.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 31,
          goodsPic: require("../assets/drug-31.png"),
          goodsName: "欧姆龙压缩式雾化器",
        },
        {
          id: 32,
          goodsPic: require("../assets/drug-32.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 33,
          goodsPic: require("../assets/drug-33.png"),
          goodsName: "压力绷带（束腹带）",
        },
        {
          id: 34,
          goodsPic: require("../assets/drug-34.png"),
          goodsName: "压力绷带（全扣式加强型束腹带）",
        },
        {
          id: 35,
          goodsPic: require("../assets/drug-35.png"),
          goodsName: "上臂式电子血压计",
        },
        {
          id: 36,
          goodsPic: require("../assets/drug-36.png"),
          goodsName: "医用固定带",
        },
      ],
      goodsList1: [
        {
          id: 1,
          goodsPic: require("../assets/drug-1.jpg"),
          goodsName: "感冒灵颗粒",
        },
        {
          id: 2,
          goodsPic: require("../assets/drug-2.png"),
          goodsName: "板蓝根颗粒",
        },
        {
          id: 3,
          goodsPic: require("../assets/drug-3.png"),
          goodsName: "咽炎片",
        },
        {
          id: 4,
          goodsPic: require("../assets/drug-4.png"),
          goodsName: "感冒清热颗粒",
        },
        {
          id: 5,
          goodsPic: require("../assets/drug-5.png"),
          goodsName: "夏桑菊颗粒",
        },
      ],
      goodsList2: [
        {
          id: 6,
          goodsPic: require("../assets/drug-6.png"),
          goodsName: "健胃消食片",
        },
        {
          id: 7,
          goodsPic: require("../assets/drug-7.png"),
          goodsName: "肠炎宁片",
        },
        {
          id: 8,
          goodsPic: require("../assets/drug-8.png"),
          goodsName: "奥美拉唑肠溶胶囊",
        },
        {
          id: 9,
          goodsPic: require("../assets/drug-9.png"),
          goodsName: "养胃舒胶囊",
        },
        {
          id: 10,
          goodsPic: require("../assets/drug-10.png"),
          goodsName: "铝碳酸镁片",
        },
      ],
      goodsList3: [
        {
          id: 11,
          goodsPic: require("../assets/drug-11.png"),
          goodsName: "维生素AD滴剂",
        },
        {
          id: 12,
          goodsPic: require("../assets/drug-12.png"),
          goodsName: "丁桂儿脐贴",
        },
        {
          id: 13,
          goodsPic: require("../assets/drug-13.png"),
          goodsName: "葡萄糖酸锌口服溶液",
        },
        {
          id: 14,
          goodsPic: require("../assets/drug-14.png"),
          goodsName: "三公仔",
        },
        {
          id: 15,
          goodsPic: require("../assets/drug-15.png"),
          goodsName: "布洛芬混悬液",
        },
      ],
      goodsList4: [
        {
          id: 16,
          goodsPic: require("../assets/drug-16.png"),
          goodsName: "洁尔阴洗液",
        },
        {
          id: 17,
          goodsPic: require("../assets/drug-17.png"),
          goodsName: "硝呋太尔制霉素阴道软胶囊",
        },
        {
          id: 18,
          goodsPic: require("../assets/drug-18.png"),
          goodsName: "乌鸡白凤丸(水蜜丸)",
        },
        {
          id: 19,
          goodsPic: require("../assets/drug-19.png"),
          goodsName: "妇科千金片",
        },
        {
          id: 20,
          goodsPic: require("../assets/drug-20.png"),
          goodsName: "妇炎康片",
        },
      ],
      goodsList5: [
        {
          id: 21,
          goodsPic: require("../assets/drug-21.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 22,
          goodsPic: require("../assets/drug55.png"),
          goodsName: "欧姆龙电子血糖仪",
        },
        {
          id: 23,
          goodsPic: require("../assets/drug-23.png"),
          goodsName: "鱼跃电子血氧仪",
        },
        {
          id: 24,
          goodsPic: require("../assets/drug-24.png"),
          goodsName: "儿童电子温度计",
        },
        {
          id: 25,
          goodsPic: require("../assets/drug-25.png"),
          goodsName: "胎心检测仪",
        },
        {
          id: 26,
          goodsPic: require("../assets/drug-26.png"),
          goodsName: "腰椎固定带",
        },
        {
          id: 27,
          goodsPic: require("../assets/drug-27.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 28,
          goodsPic: require("../assets/drug-28.png"),
          goodsName: "欧姆龙压缩式雾化器",
        },
        {
          id: 29,
          goodsPic: require("../assets/drug-29.png"),
          goodsName: "负压拔罐器",
        },
        {
          id: 30,
          goodsPic: require("../assets/drug-30.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 31,
          goodsPic: require("../assets/drug-31.png"),
          goodsName: "欧姆龙压缩式雾化器",
        },
        {
          id: 32,
          goodsPic: require("../assets/drug-32.png"),
          goodsName: "欧姆龙电子血压计",
        },
        {
          id: 33,
          goodsPic: require("../assets/drug-33.png"),
          goodsName: "压力绷带（束腹带）",
        },
        {
          id: 34,
          goodsPic: require("../assets/drug-34.png"),
          goodsName: "压力绷带（全扣式加强型束腹带）",
        },
        {
          id: 35,
          goodsPic: require("../assets/drug-35.png"),
          goodsName: "上臂式电子血压计",
        },
        {
          id: 36,
          goodsPic: require("../assets/drug-36.png"),
          goodsName: "医用固定带",
        },
      ],
    };
  },
  created() {
    // 根据URL参数初始化显示状态
    this.initializeCategoryFromQuery();
  },
  watch: {
    // 监听路由参数变化
    '$route.query.category': {
      handler() {
        this.initializeCategoryFromQuery();
      },
      immediate: true
    }
  },
  methods: {
    initializeCategoryFromQuery() {
      const category = this.$route.query.category;
      // 重置所有显示状态
      this.isShow0 = false;
      this.isShow1 = false;
      this.isShow2 = false;
      this.isShow3 = false;
      this.isShow4 = false;
      this.isShow5 = false;

      // 根据category参数设置对应的显示状态
      switch(category) {
        case 'all':
          this.isShow0 = true;
          this.menuTitle = "全部分类";
          break;
        case 'cold':
          this.isShow1 = true;
          this.menuTitle = "感冒用药";
          break;
        case 'stomach':
          this.isShow2 = true;
          this.menuTitle = "肠胃用药";
          break;
        case 'pediatric':
          this.isShow3 = true;
          this.menuTitle = "儿科用药";
          break;
        case 'gynecological':
          this.isShow4 = true;
          this.menuTitle = "妇科药品";
          break;
        case 'medical':
          this.isShow5 = true;
          this.menuTitle = "医疗器械";
          break;
        default:
          this.isShow0 = true;
          this.menuTitle = "全部分类";
      }
    },
    handleMenuClick(e) {
      const categoryMap = {
        '0': 'all',
        '1': 'cold',
        '2': 'stomach',
        '3': 'pediatric',
        '4': 'gynecological',
        '5': 'medical'
      };
      
      // 更新路由参数
      this.$router.push({
        name: 'home',
        query: { category: categoryMap[e.key] }
      });
    },
    handleDrugDetails(id) {
        // 检查用户是否已登录
        // const isLoggedIn = localStorage.getItem('currentUser') || localStorage.getItem('isAdmin') === 'true';
        // if (!isLoggedIn) {
        //   this.$notification['info']({
        //     message: '提示',
        //     description: '该内容为付费阅读，请先登录',
        //     duration: 2,
        //     onClose: () => {
        //       // 通知关闭后自动打开登录页
        //       this.$emit('openLogin');
        //     }
        //   });
        //   return;
        // }
      // 原有的详情查看逻辑
      this.$router.push({
        name: 'drugDetails',
        params: {
          drugId: id
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.ant-carousel {
  margin: 20px auto;
  text-align: center;
  width: 1200px;
  height: auto;
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: auto;
  line-height: auto;
  // background: #364d79;
  overflow: hidden;
  img {
    vertical-align: middle;
    margin: 0 auto;
    width: 760px;
    height: auto;
  }
}
.nav {
  width: 1220px;
  margin: 20px auto;
}

.drugList {
  width: 1220px;
  height: 3660px;
  margin: 20px auto;
  .goods {
    width: 290px;
    height: 400px;
    float: left;
    background: #fff;
    transition: all 0.5s;
    // margin-bottom: 10px;
    margin-right: 15px;
    text-align: center;
    img {
      width: 206px;
      height: 206px;
      margin-top: 40px;
    }
    .goodsTitle {
      line-height: 1.2;
      font-size: 18px;
      font-weight: 800;
      color: #424242;
      margin: 20px auto;
      padding: 0 14px;
      text-align: center;
      overflow: hidden;
    }
    .isShow {
      display: none;
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin: 40px auto;
      border: 1px solid #e1e1e1;
      border-radius: 4px;
      font-size: 12px;
      color: #646464;
      cursor: pointer;
      background-color: #f9f9f9;
      background-image: linear-gradient(180deg, #fff, #f9f9f9);
    }
    .isShow:hover {
      background: #f9f9f9;
    }
  }
  .goods:hover {
    box-shadow: 0px 0px 30px #ccc;
    transform: scale(1.1);
    .isShow {
      display: block;
    }
  }
}

.footer {
  background: 0;
  width: 100%;
  height: 100px;
  color: #757575;
  font-size: 12px;
  text-align: center;
}
</style>
